let data = null;

const worker = { data };

module.exports = worker;